import { useState, type FormEvent } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/dagmhj9tto0ceqqnhvsg";

const brandPoints = [
  "每日 20:00 准时上新，快乐不缺席",
  "收录全网 500+ 沙雕与奇葩赛事",
  "内容轻松解压，不做营销夹带",
  "吃瓜围观 + 收藏转发一键搞定",
];

export default function CtaSubscribe() {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honey = (formData.get("website_alt") || "").toString().trim();

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== "website_alt") payload.append(key, value.toString());
    });

    // honeypot 命中：不做真实提交，仅返回与成功一致的提示，避免被机器人识别
    if (honey) {
      setStatus("success");
      form.reset();
      return;
    }

    setStatus("sending");
    setErrorMsg("");
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || (parsed?.code ? "" : responseText || "");
      if (!res.ok || parsed?.code !== "OK") {
        const msg = serverMsg && !/spam/i.test(serverMsg) ? serverMsg : "订阅失败，请稍后重试或换个邮箱试试。";
        setStatus("error");
        setErrorMsg(msg);
        return;
      }
      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
      setErrorMsg("网络开小差了，请稍后再试一次。");
    }
  }

  return (
    <section id="subscribe" className="scroll-mt-20 bg-background-100/80 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="flex items-center gap-2 text-sm font-bold tracking-wide text-primary-600">
            <i className="ri-sparkling-2-fill" />
            关于每日大赛
          </span>
          <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
            把每天的快乐，打包送进你邮箱
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            每日大赛是一个专注盘点沙雕比赛合集、奇葩赛事、民间高手与迷惑行为的轻松内容站。我们相信再忙的日子，也值得留几分钟给离谱的快乐。订阅后，每天精选一条最上头的赛报，准时抵达你的收件箱。
          </p>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2">
            {brandPoints.map((point) => (
              <li key={point} className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="mt-0.5 text-primary-500 ri-checkbox-circle-fill" />
                {point}
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-3xl border border-background-200 bg-background-50 p-6 md:p-8">
          <h3 className="text-lg font-bold text-foreground-900">订阅每日快乐精选</h3>
          <p className="mt-1 text-sm text-foreground-600">留下邮箱，每天 20:00 不见不散。</p>

          {status === "success" ? (
            <div className="mt-6 rounded-2xl bg-accent-50 p-5 text-sm text-accent-900">
              <i className="mr-1 ri-checkbox-circle-fill text-accent-600" />
              订阅成功！从今天起，快乐会准时来敲门，记得查收邮箱哦。
            </div>
          ) : (
            <form
              data-readdy-form="每日大赛-邮件订阅"
              className="mt-6"
              onSubmit={handleSubmit}
              noValidate
            >
              <label htmlFor="subscribe-email" className="text-sm font-medium text-foreground-700">
                邮箱地址
              </label>
              <div className="mt-2 flex flex-col gap-3 sm:flex-row">
                <input
                  id="subscribe-email"
                  type="email"
                  name="email"
                  required
                  autoComplete="email"
                  placeholder="name@example.com"
                  className="h-12 w-full rounded-full border border-background-300 bg-background-50 px-5 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
                <button
                  type="submit"
                  disabled={status === "sending"}
                  className="inline-flex h-12 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-semibold text-background-50 transition hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {status === "sending" ? (
                    <>
                      <i className="ri-loader-4-line animate-spin" />
                      订阅中
                    </>
                  ) : (
                    <>
                      <i className="ri-mail-add-line" />
                      立即订阅
                    </>
                  )}
                </button>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              {status === "error" && (
                <p className="mt-3 flex items-start gap-2 text-sm text-primary-700">
                  <i className="mt-0.5 ri-alert-line" />
                  {errorMsg}
                </p>
              )}
              <p className="mt-4 text-xs leading-relaxed text-foreground-500">
                订阅即表示你同意我们向你发送每日趣味内容。可随时退订，放心交心。
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}